import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useEffect, useState } from 'react';
import { arrayOf, string, number, oneOfType, func, bool } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import Flex from '../../atoms/Flex';
import Image from '../../atoms/ResponsiveImage';
import { MiniatureItem } from './MediaThumbnails.styles';

const MediaThumbnails = _ref => {
  let {
    alt,
    title,
    audio,
    images,
    video,
    imgWidth,
    imgHeight,
    imgMaxHeight,
    onImageClick,
    onAudioClick,
    onVideoClick,
    showMedia,
    showMoreTooltip,
    smallThumbnails,
    preload
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["alt", "title", "audio", "images", "video", "imgWidth", "imgHeight", "imgMaxHeight", "onImageClick", "onImageChange", "onAudioClick", "onVideoClick", "showMedia", "showMoreTooltip", "smallThumbnails", "preload"]);

  const [imageSelected, setImageSelected] = useState({
    image: images[0],
    index: 0
  });

  const handleImageClick = index => {
    onImageClick(index);
  };

  useEffect(() => {
    setImageSelected({
      image: images[0],
      index: 0
    });
  }, [images]);
  return /*#__PURE__*/React.createElement(Flex, _extends({
    columnGap: 4,
    maxHeight: 614,
    "data-testid": "media-gallery"
  }, props), /*#__PURE__*/React.createElement(Flex, {
    rowGap: 3,
    flexDirection: "column",
    width: "fit-content"
  }, images.slice(0, images.length > 5 ? 4 : images.length).map((image, index) => /*#__PURE__*/React.createElement(MiniatureItem, {
    key: `gallery-img-${index}`,
    selected: index === imageSelected.index,
    smallThumbnails: smallThumbnails
  }, /*#__PURE__*/React.createElement(Image, {
    alt: alt,
    title: title,
    "data-testid": "media-gallery-image",
    src: image,
    width: 90,
    height: 90,
    onClick: () => setImageSelected({
      image,
      index
    }),
    onMouseOver: () => setImageSelected({
      image,
      index
    })
  }))), images.length > 5 && /*#__PURE__*/React.createElement(Flex, {
    "data-testid": "media-gallery-image-more",
    fontSize: 5,
    fontWeight: "bold",
    borderRadius: "default",
    width: smallThumbnails ? '84px' : '110px',
    height: smallThumbnails ? '66px' : '110px',
    title: showMoreTooltip,
    alignItems: "center",
    justifyContent: "center",
    bg: "background.base",
    color: "text.base",
    cursor: "pointer",
    onClick: () => onImageClick(4)
  }, "+ ", images.length - 4)), /*#__PURE__*/React.createElement(Flex, {
    flex: 1,
    maxHeight: 614,
    position: "relative"
  }, /*#__PURE__*/React.createElement(Image, {
    "data-testid": "image-selected-thumbnail",
    src: imageSelected.image,
    maxHeight: imgMaxHeight,
    width: imgWidth,
    height: imgHeight,
    alt: alt,
    title: title,
    lazy: !preload || imageSelected.index !== 0,
    onClick: () => handleImageClick(imageSelected.index),
    cursor: "pointer"
  }), showMedia && /*#__PURE__*/React.createElement(Flex, {
    gap: 2,
    position: "absolute",
    bottom: 0,
    left: 0,
    "data-testid": "media-gallery-icons"
  }, !!video && /*#__PURE__*/React.createElement(Icon, {
    name: "VideoCircle",
    cursor: "pointer",
    width: "40px",
    height: "40px",
    "data-testid": "media-gallery-video-icon",
    onClick: onVideoClick
  }), !!audio && /*#__PURE__*/React.createElement(Icon, {
    name: "PodcastCircle",
    cursor: "pointer",
    width: "40px",
    height: "40px",
    "data-testid": "media-gallery-audio-icon",
    onClick: onAudioClick
  }))));
};

process.env.NODE_ENV !== "production" ? MediaThumbnails.propTypes = {
  audio: string,
  video: string,
  images: arrayOf(string),
  imgWidth: number,
  imgHeight: number,
  imgMaxHeight: oneOfType([number, string]),
  alt: string,
  title: string,
  onImageClick: func,
  onImageChange: func,
  onVideoClick: func,
  onAudioClick: func,
  showMedia: bool,
  showMoreTooltip: string,
  smallThumbnails: bool,
  preload: bool
} : void 0;
MediaThumbnails.defaultProps = {
  audios: [],
  images: [],
  podcasts: [],
  videos: [],
  imgWidth: 600,
  imgHeight: 600,
  imgMaxHeight: '40vh',
  alt: '',
  title: '',
  showMoreTooltip: '',
  smallThumbnails: false,
  preload: false
};
export default MediaThumbnails;